const KENDRA_ANSWER_KEY = 'AnswerText';
const MAX_SEARCH_RESULT_LENGTH = 5;

const highLightElements = {
  start: '<strong>',
  end: '</strong>',
};

export {
  KENDRA_ANSWER_KEY,
  MAX_SEARCH_RESULT_LENGTH,
  highLightElements,
};
